// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cgqgww_qtSoTnAq2e5YA{box-sizing:border-box;display:flex;align-items:center;justify-content:center;cursor:pointer;height:100%;position:relative;width:100%;pointer-events:auto}.pnB7dqbxTfFe4XZS_5K2{position:relative;display:flex;align-items:center;justify-content:center}.Y8SnGZHGmMKYK4uL7oAc{position:absolute;top:-1px;right:-1px;width:6px;height:6px;background-color:#f47321;border-radius:50%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Cgqgww_qtSoTnAq2e5YA`,
	"imgContainer": `pnB7dqbxTfFe4XZS_5K2`,
	"unreadDot": `Y8SnGZHGmMKYK4uL7oAc`
};
export default ___CSS_LOADER_EXPORT___;
